<template>
  <b-card no-body id="printMe">
    <b-card-header
      class="text-center p-3 bg-primary"
      style="display: flex; justify-content: space-between"
    >
      <h2 class="text-white">{{ $t("testResult") }}</h2>
      <b-button-group>
        <!-- <b-button variant="outline-light" @click="print">
          <i style="font-size:20px" class="fa fa-print"></i>
        </b-button> -->
        <b-button variant="outline-light" class="button">
          <router-link
            to="/profile"
            style="color: #ffffff; text-decoration: none"
            ><h5>{{ $t("employees.profileBack") }}</h5></router-link
          >
        </b-button>
      </b-button-group>
    </b-card-header>
    <div v-if="isLoader" class="text-center">
      <b-spinner label="Loading..."></b-spinner>
    </div>

    <div v-if="!isLoader" ref="document">
      <div class="d-flex pl-4 pr-4 pt-4 pb-0">
        <div class="mt-1">
          <h5 class="mb-3">
            {{ $t("EmployeeFIO") }}:
            <strong>
              {{ testEmployee.employeeLastName }}
              {{ testEmployee.employeeFirstName }}

              {{ testEmployee.employeeParentName }}
            </strong>
          </h5>
          <h5 class="mb-3">
            {{ $t("allTest") }}:
            <strong>30</strong>
          </h5>
          <h5 class="mb-3">
            {{ $t("allTestCorrect") }}:
            <strong v-if="testEmployee">{{ testEmployee.corrects }}</strong>
          </h5>
          <h5 class="mb-3">
            {{ $t("allTestNoCorrect") }}:
            <strong>{{ noCorrect }}</strong>
          </h5>
        </div>
        
      </div>

      <div class="text-center ml-5 pl-5" v-if="testEmployee">
          <radial-progress-bar
            :strokeWidth="20"
            :innerStrokeWidth="20"
            :diameter="200"
            :completed-steps="testEmployee.corrects"
            :total-steps="30"
            startColor="#007BFF"
            stopColor="#007BFF"
          >
            <h2>{{ testEmployee.correctsInProportion + "%" }}</h2>
          </radial-progress-bar>
          <h5 class="m-0">{{ 30 + "/" + testEmployee.corrects }}</h5>
        </div>
    </div>
  </b-card>
</template>
<script>
import { mapState } from "vuex";
import vacancyService from "@/services/vacancy.service";
import RadialProgressBar from "vue-radial-progress";
import { validationMixin } from "vuelidate";
import { TokenService } from "@/services/storage.service";

export default {
  mixins: [validationMixin],
  created() {
    this.getResult();
  },
  components: {
    RadialProgressBar,
  },
  computed: {
    ...mapState("employee", ["candidateData", "employeeTestResult"]),
  },
  data() {
    return {
      noCorrect: null,
      isLoader: false,
      isShow: true,
      isTrue: true,
      questionsDto: null,
      testEmployee: null,
    };
  },
  methods: {
    print() {
      window.print();
    },
    async getResult() {
      try {
        this.isLoader = true;

        await this.setResult(this.employeeTestResult);
        this.isLoader = false;
      } catch (e) {
        await this.setResult(null);
      }
    },
    setResult(data) {
      this.$nextTick(() => {
        // this.questionsDto = data.questionsDto;
        this.testEmployee = data;
        this.noCorrect = 30 - data.corrects;
      });
    },
  },
};
</script>
<style>
/* @media screen {
  #printMe {
      display: none;
  }
} */
@media print {
  body * {
    visibility: hidden;
  }

  #printMe,
  #printMe * {
    visibility: visible;
  }

  .modal.show .modal-dialog {
    margin: 0;
  }

  #printMe {
    position: absolute;
    left: 0;
    top: 0;
  }
}

.con {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}

.button:hover {
  background: #0037ff;
}
</style>
